import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-audience-size-message',
  templateUrl: './audience-size-message.component.html',
  styleUrls: ['./audience-size-message.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AudienceSizeMessageComponent {
  @Input() audienceSize?: number;
  @Input() timestamp: Date = new Date();

  get shouldDisplay(): boolean {
    return this.audienceSize !== undefined && this.audienceSize < 50000;
  }

  get isCritical(): boolean {
    return this.audienceSize !== undefined && this.audienceSize < 10000;
  }

  get formattedSize(): string {
    if (!this.audienceSize) return '';

    if (this.audienceSize < 1000) {
      return this.audienceSize.toLocaleString();
    }

    if (this.audienceSize < 1000000) {
      if (this.audienceSize >= 47500 && this.audienceSize < 50000) {
        return 'under 50K';
      }
      const thousands = this.audienceSize / 1000;
      return thousands % 1 === 0 ? `${thousands}K` : `${thousands.toFixed(1)}K`;
    }

    const millions = this.audienceSize / 1000000;
    return millions % 1 === 0 ? `${millions}M` : `${millions.toFixed(1)}M`;
  }

  get formattedTime(): string {
    return this.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
}
